import { Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'

export default function Register() {
  const form = useForm({ email_address: '', password: '', password_confirmation: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/registration')
  }

  return (
    <AuthShell
      title="注册"
      subtitle="创建账号，开始管理你和家人的习惯积分。"
      footer={
        <>
          已有账号？<Link href="/session/new" className="text-[#5b7cfa] font-semibold">登录</Link>
        </>
      }
    >
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label="邮箱"
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={form.data.email_address}
          error={form.errors.email_address}
          onChange={(e) => form.setData('email_address', e.target.value)}
        />
        <Field
          label="密码"
          type="password"
          autoComplete="new-password"
          required
          maxLength={72}
          placeholder="至少 8 位"
          value={form.data.password}
          error={form.errors.password}
          onChange={(e) => form.setData('password', e.target.value)}
        />
        <Field
          label="确认密码"
          type="password"
          autoComplete="new-password"
          required
          maxLength={72}
          value={form.data.password_confirmation}
          error={form.errors.password_confirmation}
          onChange={(e) => form.setData('password_confirmation', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? '创建中…' : '创建账号'}</SubmitButton>
      </form>
    </AuthShell>
  )
}
